import type { Lang } from "@/i18n/types";

export const REGISTER_BASE = "https://ui.freecrm.com/register";

const langQuery: Record<Lang, string> = {
  en: "?lang=en",
  es: "?lang=es",
  fr: "?lang=fr",
  pt: "?lang=pt",
  it: "?lang=it",
  de: "?lang=de",
  ar: "?lang=ar",
  ru: "?lang=ru",
};

export function getRegisterUrl(lang?: Lang): string {
  return `${REGISTER_BASE}${lang ? langQuery[lang] ?? "" : ""}`;
}

export const LOGIN_BASE = "https://ui.freecrm.com/login";

export function getLoginUrl(lang?: Lang): string {
  return `${LOGIN_BASE}${lang ? langQuery[lang] ?? "" : ""}`;
}
